import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducers';

import TripCategoryFilter from '../../../Components/TripCategoryFilter';
import TripCard, { TripData } from '../TripCard';
import { request } from '../../../Utils/request';
import { ITrip } from '../Trips';
import { paiseToRupees } from '../../../Utils/currencyConverter';
import { fetchCategories } from '../../../services/CommonApiCall';

interface TripsTabProps {
  onTripEdit: (trip: TripData) => void;
  onTripShare: (trip: TripData) => void;
  onTripClick: (trip: TripData) => void;
}

const TripsTab: React.FC<TripsTabProps> = ({
  onTripEdit,
  onTripShare,
  onTripClick,
}) => {
  const dispatch = useDispatch();
  const [trips, setTrips] = useState<ITrip[]>([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = useSelector((state: RootState) => state.category?.categories || []);
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);

  useEffect(() => {
    fetchCategories(dispatch, 'trip-itinerary');
  }, [dispatch]);

  useEffect(() => {
    const fetchTrips = async () => {
      request<{ success: boolean; data: ITrip[], message: string }>('/trips/user/my-trips', {
        method: 'GET',
        authorization: true,
      }).then((res) => {
        const trip_data = res?.data;
        setTrips(trip_data);
      }).catch((err) => {
        console.log('error', err);
      });
    };
    if(isLoggedIn)
    fetchTrips();
  }, [isLoggedIn]);

  if(trips.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          No trips found
        </Typography>
      </Box>
    )
  }
  return (
    <>
      <TripCategoryFilter
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={setSelectedCategory}
        showViewAll
      />

      <Stack spacing={2} mb={6}>
        {trips.map((trip) => {
          const transformedTrip: TripData = {
            id: trip._id,
            title: trip.title,
            location: trip.location?.name || '',
            duration: `${trip.schedule?.dailySchedule?.length || 0} Days`,
            price: `₹${paiseToRupees(trip.pricePerPerson).toFixed(2)}/person`,
            imageUrl: trip.files?.[0]?.fileURL || '',
            category: trip.category?.[0] || '',
            type: (trip as any).type || 'Trip',
            status: (trip as any).status || '',
          };

          return (
            <TripCard
              key={transformedTrip.id}
              trip={transformedTrip}
              variant="trips"
              onEdit={onTripEdit}
              onShare={onTripShare}
              onClick={onTripClick}
            />
          );
        })}
      </Stack>
    </>
  );
};

export default TripsTab;
